module.exports = __webpack_public_path__ + "static/media/map-serrazul-1.bd52e00e.png";